import Model, { toProp } from "./Model";

/**
 *
 * @class HumanName
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/model/HumanName.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

class HumanName extends Model {
  constructor(modelData) {
    super()

    /** @type string */
    this.id = toProp()

    /** @type string */
    this.use = toProp()

    /** @type string[] */
    this.given = toProp()

    /** @type string */
    this.family = toProp()

    this.buildModel(modelData)
  }
}

export default HumanName